export default __webpack_public_path__ + "static/media/014_photo.853e0f6f.jpg";